export function toPercentage(number, toFixed = 2) {
  if (typeof number !== 'number') {
    console.error('first arg in function "toPercentage" is not a number');
    return '-';
  }
  return (number * 100).toFixed(toFixed) + '%';
}



// WEBPACK FOOTER //
// ./src/utils/index.js